import React, { useState } from "react";
import { Box, Typography, Collapse, Container } from "@mui/material";
import { Plus, Minus } from "lucide-react";

const faqData = [
  {
    pregunta: "¿Qué necesito para registrarme como usuario en Clinifica?",
    respuesta: (
      <>
        <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6, mb: 1.5 }}>
          Para formar parte de nuestra comunidad de profesionales de salud, solo necesitas cumplir con tres requisitos:
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, m: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Ser profesional de la salud: Contar con tu registro vigente en la Superintendencia de Salud.
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Espíritu Independiente: Tener la determinación de potenciar tu propia marca y carrera profesional.
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Mentalidad de Crecimiento: Involucrarte con la tecnología y aprovechar nuestra plataforma para escalar tu práctica al siguiente nivel.
            </Typography>
          </li>
        </Box>
      </>
    )
  },
  {
    pregunta: "¿Tiene costo registrarme en Clinifica?",
    respuesta: (
      <>
        <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6, mb: 1.5 }}>
          Empezar es gratis. Al registrarte, obtienes el Plan Gratuito para siempre.
        </Typography>
      </>
    )
  },
  {
    pregunta: "¿Qué servicios y modalidades puedo ofrecer?",
    respuesta: (
      <>
        <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6, mb: 1.5 }}>
          En Clinifica te damos la libertad de diversificar tus ingresos y compartir tu experiencia en múltiples formatos, desde tu plataforma puedes ofrecer:
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, m: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Consultas o Sesiones Clínicas: Las prestaciones de salud tradicionales derivadas de tu profesión. Tus pacientes podrán agendar atenciones presenciales, a domicilio o por videollamada de forma sencilla.
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Recursos y Contenido Digital: ¿Tienes guías, e-books o material de apoyo valioso? Puedes monetizar tu conocimiento vendiendo contenido digital directamente a tus pacientes o colegas.
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Tickets para Eventos: Si te gusta enseñar o dar charlas, puedes organizar eventos (online o presenciales). El usuario simplemente compra su entrada a través de tu perfil, asegurando su cupo automáticamente.
            </Typography>
          </li>
        </Box>
      </>
    )
  },
  {
    pregunta: "¿Qué costo tiene la suscripción mensual al Plan Pro?",
    respuesta: (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
        El Plan Pro, que incluye absolutamente todas nuestras herramientas de automatización y gestión, tiene un valor mensual de $19.990 + IVA ($23.788 en total). Este monto se carga automáticamente a tu método de pago registrado cada mes.
      </Typography>
    )
  },
  {
    pregunta: "¿Puedo pagar el plan anual en cuotas?",
    respuesta: (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
        Sí. Puedes dividirlo en hasta 12 cuotas con tarjeta de crédito de cualquier banco. Si decides volver al Plan Gratuito antes de terminar el año, tienes total libertad para hacerlo, pero no aplican devoluciones.
      </Typography>
    )
  },
  {
    pregunta: "¿Existen costos por aceptar pagos con tarjeta de crédito o débito?",
    respuesta: (
      <>
        <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6, mb: 1.5 }}>
          Sí, hay un costo asociado a las pasarelas de pago (la tecnología de transbank que permite aceptar tarjetas de crédito y débito) y varía según tu plan:
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, m: 0, display: "flex", flexDirection: "column", gap: "10px", mb: 1.5 }}>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Plan Pro: Costo del 3.89% para tarjetas de crédito y débito.
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontFamily: "Quicksand-Regular", color: "#454545", fontSize: { xs: "14px", md: "16px" } }}>
              Plan Gratuito: Costo del 6.89% para tarjetas de crédito y débito.
            </Typography>
          </li>
        </Box>
        <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
          Este costo aplica únicamente cuando un paciente paga con tarjetas. Si el paciente te paga en efectivo o transferencia a tu cuenta, este costo no aplica.
        </Typography>
      </>
    )
  },
  {
    pregunta: "¿Tengo que pagar algo adicional a mi suscripción?",
    respuesta: (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
        En Clinifica no hay letras chicas. Cuando pagas tu suscripción al Plan Pro, no te cobramos adicional por gestionar a tus pacientes con las funcionalidades de Clinifica. Puedes emitir todas las boletas de honorarios que quieras, enviar todos los recordatorios por WhatsApp que necesiten tus pacientes y gestionar a todos tus pacientes, sin límite.
      </Typography>
    )
  },
  {
    pregunta: "¿Es privada la información que subo a la plataforma?",
    respuesta: (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
        En Clinifica, toda la información está encriptada y protegida bajo altos estándares. Solo tú tienes acceso a las fichas, agendas y datos que has escrito o almacenado en tu cuenta. Tu consulta está en un entorno digital seguro, diseñado para que puedas dedicarte a tus pacientes con total tranquilidad.
      </Typography>
    )
  },
  {
    pregunta: "¿Qué pasa con mis datos y fichas clínicas si cancelo el Plan Pro?",
    respuesta: (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "14px", md: "16px" }, color: "#454545", lineHeight: 1.6 }}>
        Son tuyos. Al cancelar el Plan Pro, tu cuenta vuelve automáticamente al Plan Gratuito y toda tu información (fichas, notas y sesiones) permanece segura y accesible. No retenemos tu información ni la usamos para otros fines, cumpliendo siempre con la legislación vigente.
      </Typography>
    )
  }
];

const PreguntasFrecuentes = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 10 }}>
      {/* Título de la sección */}
      <Typography
        sx={{
          fontFamily: "Poppins-SemiBold",
          fontSize: { xs: "24px", md: "36px" },
          color: "#141414",
          textAlign: "center",
          mb: { xs: 4, md: 5 },
        }}
      >
        Preguntas frecuentes
      </Typography>

      {/* Listado de preguntas */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {faqData.map((item, index) => {
          const isOpen = expandedIndex === index;
          return (
            <Box
              key={index}
              onClick={() => handleToggle(index)}
              sx={{
                width: "100%",
                p: { xs: "20px", md: "28px" },
                borderRadius: { xs: "16px", md: "20px" },
                background: "#ffffff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.01), 0 4px 10px rgba(0,0,0,0.01), 0 8px 16px rgba(0,0,0,0.02)",
                border: "1px solid #eaeaea",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
            >
              {/* Encabezado de la pregunta */}
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography
                  sx={{
                    fontFamily: "Poppins-SemiBold",
                    fontSize: { xs: "15px", md: "17px" },
                    color: "#141414",
                    pr: 2,
                    textAlign: "left",
                  }}
                >
                  {item.pregunta}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#999",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "all 0.3s ease",
                    flexShrink: 0,
                  }}
                >
                  {isOpen ? <Minus size={20} strokeWidth={2.5} /> : <Plus size={20} strokeWidth={2.5} />}
                </Box>
              </Box>

              {/* Contenido expandible */}
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <Box
                  onClick={(e) => e.stopPropagation()} // Evita cerrar al hacer click dentro de la respuesta
                  sx={{
                    mt: 1.5,
                    textAlign: "left"
                  }}
                >
                  {item.respuesta}
                </Box>
              </Collapse>
            </Box>
          );
        })}
      </Box>
    </Container>
  );
};

export default PreguntasFrecuentes;
